import CheckIcon from '@mui/icons-material/Check'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

export interface RetireConfirmDialogProps {
  open: boolean
  displayName: string
  busy?: boolean
  onCancel: () => void
  onConfirm: () => void
}

const STAYS_TRUE = [
  'avatarStudio.retire.staysTrue.savedAvatars',
  'avatarStudio.retire.staysTrue.restorable',
]

export default function RetireConfirmDialog({
  open,
  displayName,
  busy = false,
  onCancel,
  onConfirm,
}: RetireConfirmDialogProps) {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth={true}>
      <DialogTitle>
        {formatMessage({ id: 'avatarStudio.retire.title' }, { name: displayName })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {formatMessage({ id: 'avatarStudio.retire.body' })}
        </DialogContentText>
        <Stack spacing={1} sx={{ mt: 2 }}>
          {STAYS_TRUE.map((id) => (
            <Stack key={id} direction="row" spacing={1} alignItems="flex-start">
              <CheckIcon fontSize="small" color="success" aria-hidden={true} />
              <Typography variant="body2">{formatMessage({ id })}</Typography>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          {formatMessage({ id: 'avatarStudio.editor.cancel' })}
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={busy}>
          {formatMessage({ id: 'avatarStudio.retire.confirm' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
